import { Component, input, linkedSignal } from '@angular/core';

/**
 * The product gallery: one large photo with a column of thumbnails beside it.
 *
 * <p>slick drew the thumbnails through `customPaging`, which built an `<img>` out of each slide's
 * `data-thumb` and appended the lot into `.wrap-slick3-dots`. Both the source and the destination
 * were server-rendered elements, so the move was one of the things hydration could not follow.
 * The thumbnails are now just a list rendered from the same array as the photos.
 */
@Component({
  selector: 'photo-slider',
  host: {
    style: 'display: contents'
  },
  template: `
    <div class="wrap-slick3 flex-sb flex-w">
      <div class="wrap-slick3-dots">
        <ul class="slick3-dots">
          @for (photo of photos(); track $index; let index = $index) {
            <li [class.active]="index === current()">
              <img [src]="photo" [alt]="alt()">
              <!-- The overlay covers the thumbnail, so it has to be the thing that is clicked;
                   as a button it is keyboard-reachable too, which the theme's div was not. -->
              <button type="button" class="slick3-dot-overlay"
                [attr.aria-label]="'Фото ' + (index + 1)"
                [attr.aria-current]="index === current() ? 'true' : null"
                (click)="current.set(index)"></button>
            </li>
          }
        </ul>
      </div>
      <div class="slick3">
        @for (photo of photos(); track $index; let index = $index) {
          <div class="item-slick3" [class.active]="index === current()"
            [attr.aria-hidden]="index === current() ? null : 'true'">
            <div class="wrap-pic-w">
              <a data-lightbox="product-photo" [href]="photo">
                <img [src]="photo" [alt]="alt()">
              </a>
            </div>
          </div>
        }
      </div>
    </div>
    `
})
export class PhotoSliderComponent {

  readonly photos = input.required<string[]>();
  readonly alt = input.required<string>();

  // The colour and size choosers keep this component and hand it another product's photos.
  readonly current = linkedSignal({ source: this.photos, computation: () => 0 });

}
